<template>
  <div class="container Pos-r">
    <div class="list">
      <Row class="item-wrap" type="flex" align="middle" v-for="(item, index) in list" :key="index" @click.native="showResume(item)">
        <Col span="6">
          <Row type="flex" align="middle">
            <Col span="6">
              <img :src="item.avatar || '//weapp-cdn.gongjiayun.cn/avatar_default.png'" />
            </Col>
            <Col span="16">
              <div class="Opacit-7">
                <span class="name">{{ item.name }}</span>
                {{ item.expectations && item.expectations.limit_msg }}
              </div>
            </Col>
          </Row>
        </Col>
        <Col span="7" class="descrption zan-ellipsis--l3">{{ item.brief }}</Col>
        <Col span="5" class="Align-c">{{ item.message_historys && item.message_historys.created_at }}</Col>
        <Col span="6" class="Opacit-5" v-if="item.message_historys && item.message_historys.remark">
          备注：{{ item.message_historys.remark }}
        </Col>
      </Row>
    </div>
    <Page v-if="pagination.total" :total="pagination.total" :page-size="pagination.perPage" show-elevator @on-change="changePage" />
    <no-data v-else>暂无数据</no-data>
    <Modal v-model="isShow" width="1100" :closable="false">
      <resume-detail :resume="resume" @closePopup="closePopup"></resume-detail>
    </Modal>
  </div>
</template>

<script>
import ResumeDetail from '_c/resume-detail/resume-detail';

export default {
  name: '',
  components: { ResumeDetail },

  data() {
    return {
      pagination: {},
      list: [],
      isShow: false,
      resume: {}
    };
  },
  methods: {
    changePage(page) {
      this.getData(page);
    },
    getData(page = 1) {
      this.$axios
        .request({
          url: 'api/qiuzhi/message/resumeList?page=' + page
        })
        .then(res => {
          if (res.data.length == 0) {
            return;
          }
          this.list = this.list.concat(res.data);
          this.pagination = res.pagination;
          if (!this.list || !this.list.length) {
            this.noData = true;
          }
        });
    },
    showResume(item) {
      this.isShow = true;
      this.resume = item;
      this.$axios.request({
        url: 'front/v1/company-resume/read',
        method: 'post',
        data: {
          id: item.id
        }
      });
    },
    closePopup() {
      this.isShow = false;
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="less" scoped>
.item-wrap {
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(238, 238, 238, 1);
  padding: 20px;
  font-size: 14px;
  margin-bottom: 20px;
  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
  .name {
    font-size: 18px;
    opacity: 1;
    color: #363e4f;
    margin-right: 5px;
  }
  .descrption {
    color: #686f82;
  }
}
</style>
